const firebaseConfig = {
    apiKey: "AIzaSyCSvBdYx-LzL2lFXwI-kemYJ_--KlkWPXY",
    authDomain: "events-maker.firebaseapp.com",
    projectId: "events-maker",
    storageBucket: "events-maker.appspot.com",
    messagingSenderId: "714182066833",
    appId: "1:714182066833:web:58c65955eee60315c4b530"
  };

  export default firebaseConfig;